import { Injectable, computed, effect, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SiteContextService {
  private readonly hostname = signal(window.location.hostname.toLowerCase());

  readonly localHost = computed(() =>
    this.hostname() === 'localhost' || this.hostname() === '127.0.0.1'
  );

  readonly testSite = computed(() =>
    this.hostname() === 'test.app.mycableengineering.com'
  );

  readonly productionSite = computed(() =>
    this.hostname() === 'app.mycableengineering.com'
  );
}
